import { useState, useCallback } from 'react';
import { UsersApi } from '../../clients';

export const useAssignUserFacilities = () => {
  const [state, setState] = useState({
    loading: false,
    error: null,
  });

  const assignFacilities = useCallback(
    async (facilityUserId, { facilityIds, allFacilities }) => {
      setState({
        loading: true,
        error: null,
      });

      try {
        const response = await UsersApi.assignUserFacilities(facilityUserId, {
          facilityIds,
          allFacilities,
        });
        setState({
          loading: false,
          error: null,
        });
        return response.data;
      } catch (error) {
        console.error('Error assigning user facilities:', error);
        setState({
          loading: false,
          error:
            error.response?.data?.message || 'Failed to assign user facilities',
        });
        throw error;
      }
    },
    [],
  );

  return {
    ...state,
    assignFacilities,
  };
};
